import React, { Component } from 'react';
import { connect } from 'react-redux';
import shared from '../../utils/shared';
import _ from 'lodash';
import { getFileType } from '../../utils/fileHelpers';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
// import ReactPlayerWrapper from './ReactPlayerWrapper';
// import ReactPlayer from 'react-player';

class Slideshow extends Component {

  constructor(props) {
    super(props);
    this._totalElements = this.props.module.contents.images.length;
    this._cycleOverrides = this.props.module.contents.cycle_overrides;
    this._currentDuration = 0;
    this._startSlideTime = 0;
    this._paused = false;
    this._videoRef = null;
    this.state = {
      activeSlide: 0,
      videoVolumes: Array.from(Array(this.props.module.contents.images.length), () => 0),
      module: this.props.module
    }
    this._loadedDataTimeout = null;
  }

  componentWillMount() {
    shared.checkData(this.props.module);
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
    this.slideChanged(0);
  }

  componentWillUnmount() {
    this.clearCycleTimeout();
    clearTimeout(this._loadedDataTimeout);
    this._loadedDataTimeout = null;
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  // componentDidUpdate(prevProps, prevState){
  // 	if (this.prevProps.idle!==this.props.idle){
  // 		//if video timeout.
  // 	}
  // }

  loadedData = () => {
    // console.log("loaded data");
    if (this._videoRef!==undefined && this._videoRef!==null){
      let duration = this._videoRef.duration;
      this.handleVideoDuration(duration, 0);
    }
    else{
      this._loadedDataTimeout = setTimeout(() => {
        this.loadedData();
      }, 50);
    }

  }

  handleKeyDown = (e) => {
    switch (e.keyCode) {
      // Left Arrow (Previous)
      case 37:
        this.clearCycleTimeout();
        this.prevSlide();
        break;
      // Right Arrow (Next)
      case 39:
        this.clearCycleTimeout();
        this.nextSlide();
        break;
      // Space (Pause)
      case 32:
        if (this._videoRef) {
          this.clearCycleTimeout();
          let fileType = getFileType(this.state.module.contents.images[this.state.activeSlide].file_name);
          if (fileType !== "Image") {
            this._paused = !this._paused;
            this.toggleVideoReproduction(this._paused);
          }          
        }
        break;
      default:
        break;
    }
  }

  clearCycleTimeout = () => {
    clearTimeout(this._cycleTimeout);
    this._cycleTimeout = null;
  }

  nextSlide = () => {
    let currentSlide = this.state.activeSlide;
    let nextSlide = 0;

    if (currentSlide < (this._totalElements - 1)) {
      nextSlide = currentSlide + 1;
    }

    this.slideChanged(nextSlide);
  }

  prevSlide = () => {
    let currentSlide = this.state.activeSlide;
    let nextSlide = currentSlide - 1;

    if (currentSlide === 0) {
      nextSlide = this._totalElements - 1;
    }

    this.slideChanged(nextSlide);
  }

  toggleVideoReproduction = (paused) => {
    if (paused === true) {
      console.log('Pause');
      this._videoRef.pause();
      this._pausedOn = new Date().getTime();

      this.setState({
        activeSlide: this.state.activeSlide,
        videoVolumes: this.state.videoVolumes
      });
    } else {
      console.log('Resume');
      this._videoRef.play();
      let timeLeftToReproduce = this._currentDuration - (this._pausedOn - this._startSlideTime);

      this._currentDuration = timeLeftToReproduce;
      this._startSlideTime = new Date().getTime();

      this.clearCycleTimeout();
      this._cycleTimeout = setTimeout(() => {
        this.nextSlide();
      }, timeLeftToReproduce);

      this.setState({
        activeSlide: this.state.activeSlide,
        videoVolumes: this.state.videoVolumes
      });
    }
  }

  slideChanged = (slide) => {
    let timeout = 5000;
    this._paused = false;
    this._startSlideTime = new Date().getTime();
    
    try {
      if (this._cycleOverrides[slide] !== undefined) {
        timeout = (this._cycleOverrides[slide] * 1000);
      }
    }
    catch (error) {
      console.log(error);
    }

    let fileType = getFileType(this.state.module.contents.images[slide].file_name);
    if (fileType === "Image") {
      this.clearCycleTimeout();
      this._cycleTimeout = setTimeout(() => {
        this.nextSlide();
      }, timeout);
    }
    this.setState({
      videoRefsPulled: true,
      activeSlide: slide,
      slideChangeTime: this._startSlideTime
    });
  }

  handleVideoDuration = (duration, delay) => {
    //set our timeout for next slide

    this.clearCycleTimeout();
    this._currentDuration = (duration - delay) * 1000;
    this._cycleTimeout = setTimeout(() => {
      this.nextSlide();
    }, this._currentDuration);
  }

  getSlide = (slide) => {
    let volume = true;

    if (this.props.idle) {
      volume = false;
    }

    let innerTile = { width: this.props.screen.screenWidth, height: this.props.screen.screenHeight };
    let fileType = getFileType(this.state.module.contents.images[slide].file_name);

    if (fileType === "Image") {
      return (<img alt="Slide" onMouseDown={this.preventDrag} className="nodrag" style={innerTile} src={shared.dpath(this.props.screen.mode, this.state.module.contents.images[slide].path, this.state.module.contents.images[slide].file_name, this.props.screen.webkey)} />)
    } else {
      let videoSrc = shared.dpath(this.props.screen.mode, this.state.module.contents.images[slide].path, this.state.module.contents.images[slide].file_name, this.props.screen.webkey)
      // let videoType = shared.videoType(this.state.module.contents.images[slide].file_name);
      // return (<ReactPlayerWrapper
      //   playing={!this._paused}
      //   volume={volume}
      //   handleVideoDuration={this.handleVideoDuration}
      //   onEnded={this.videoEnded}
      //   key={slide}
      //   url={"/" + shared.dpath(this.props.screen.mode, this.state.module.contents.images[slide].path, this.state.module.contents.images[slide].file_name, this.props.screen.webkey)} width={this.props.screen.screenWidth} height={this.props.screen.screenHeight}
      // />)

      return (
        <video src={videoSrc} key={slide} style={{ width: this.props.screen.screenWidth, height: this.props.screen.screenHeight }} ref={el => this._videoRef = el} onLoadedData={this.loadedData} autoPlay muted={!volume}>
          {/* <source key={slide} src={videoSrc} type={videoType} />
          Your browser does not support the video tag. */}
        </video>
      )
    }
  }

  render() {
    return (
      <div style={{ position: 'absolute', top: 0, left: 0, width: this.props.screen.screenWidth, height: this.props.screen.screenHeight, pointerEvents: "none" }} className="nodrag">
        <CSSTransitionGroup
          component='div'
          transitionName='fastfadedelay'
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}>
          <div key={this.state.slideChangeTime} style={{ position: 'absolute', left: 0, top: 0 }}>
            {this.getSlide(this.state.activeSlide)}
          </div>
        </CSSTransitionGroup>
      </div>
    )
  }

}

const mapStateToProps = (state) => {
  let dm;
  if (state.options.idleModule === undefined) {
    dm = state.content.dm_active[state.active_module]
  }
  else {
    dm = state.content.display_module_loops[0].display_module_loop_units[state.options.idleModule].data
  }
  return {
    screen: state.screen,
    module: dm
  };
};

export default connect(mapStateToProps, null)(Slideshow);



// WEBPACK FOOTER //
// ./src/Components/Slideshow/Slideshow.js